import TextComponent from "app_components/commons/TextComponent/TextComponent";
import React, { Dispatch, SetStateAction } from "react";
import "./CharacterizationMultipleQuestion.scss"
import { IQuestionEditor } from "app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions";
import { IAttemptSurvey } from "app_types/admin/survey/survet.types";
import parse from 'html-react-parser';

interface ICharacterizationMultipleQuestionProps {
  question: IQuestionEditor
  attempt: IAttemptSurvey
  setAttempt: Dispatch<SetStateAction<IAttemptSurvey>>
}

function CharacterizationMultipleQuestion({ question, attempt, setAttempt }: ICharacterizationMultipleQuestionProps){
  const indexInAttempt = attempt?.statistics?.findIndex((answer) => answer.question === question.question._id)

  const handleChange = (answer: string) => {
    const attemptCopy = {...attempt}
    if (indexInAttempt >= 0) {
      const idx = (attemptCopy.statistics[indexInAttempt].answer as string[])?.findIndex(a => a === answer)
      if (idx >= 0) {
        (attemptCopy.statistics[indexInAttempt].answer as string[]).splice(idx, 1)
      } else {
        attemptCopy.statistics[indexInAttempt].answer = [
          ...(attemptCopy.statistics[indexInAttempt].answer?.length ? attemptCopy.statistics[indexInAttempt].answer : []),
          answer
        ]
      }
      if (attemptCopy.statistics[indexInAttempt].answer?.length === 0) {
        attemptCopy.statistics.splice(indexInAttempt, 1)
      }
    } else {
      attemptCopy.statistics.push({
        question: question.question._id as string,
        answer: [answer]
      })
    }
    setAttempt(attemptCopy)
  }

  const getCurrentValue = () => {
    return attempt?.statistics?.find((answer) => answer.question === question.question._id)?.answer
  }

  return (
    <div>
      <TextComponent fontSize="15px" color="rgb(75, 75, 75)" className="characterization-multiple-question--subtitle">
        {parse(question.question.content)}
      </TextComponent>
      <div className="characterization-multiple-question--container-questions">
        {question?.question?.answers?.map((answer) => (
          getCurrentValue()?.includes(answer._id) ? (
            <div onClick={() => handleChange(answer._id)} className="characterization-multipleQuestion--option-two">
              {parse(answer.content)}
            </div>
          ) : (
            <div onClick={() => handleChange(answer._id)} className="characterization-multiple-Question--option-one">
              {parse(answer.content)}
            </div>
          )
        ))}
      </div>
    </div>
  )

}
export default CharacterizationMultipleQuestion
